import './customLoader.styles.css'
export const CustomLoader = ({ isLoading }) => {
    // const stopScrolling = isLoading ? document.body.classList.add("no-scroll") : document.body.classList.remove("no-scroll")
    return (
        isLoading && 
        <>
            <div className="overlay show no-scroll"></div>
            <div className="spanner show">
                <div className="loader"></div>
                <p>please be patient.</p>
            </div>
        </>
    )
}